import { type FC, type ReactNode } from "react";

import { Spacing } from "@snapchat/snap-design-system";

import { Flexbox } from "../../shared/components";
import { type LensPreviewMediaItem, defaultPreviewMediaItem, getItemId } from "../../shared/state";
import { type PreviewAspectRatio } from "../models";

import { DnDPreviewCard } from "./DnDPreviewCard";

export interface SortablePreviewListProps {
    previewMediaItems: LensPreviewMediaItem[];
    uploadFile: (file: File, idx: number) => Promise<void>;
    removePreview: (idx: number) => void;
    movePreview: (oldIdx: number, newIdx: number) => void;
    editPreview: (preview: LensPreviewMediaItem, idx: number) => void;
    aspectRatio: PreviewAspectRatio;
    acceptFormats: string;
    maxNumPreviews: number;
    uploadCta: ReactNode;
}

export const SortablePreviewList: FC<SortablePreviewListProps> = ({
    previewMediaItems,
    uploadFile,
    removePreview,
    movePreview,
    editPreview,
    aspectRatio,
    acceptFormats,
    maxNumPreviews,
    uploadCta,
}) => {
    // Create array of slots to render (filled + empty slots up to MAX_NUM_PREVIEWS)
    const allSlots = Array.from({ length: maxNumPreviews }, (_, index) => {
        return previewMediaItems[index] ?? defaultPreviewMediaItem;
    });

    return (
        <Flexbox flexDirection="column" alignItems="stretch" gap={`${Spacing.SM}px`} style={{ width: "100%" }}>
            {allSlots.map((preview, index) => {
                const isEmpty = preview.type === "default";

                return (
                    <div key={`${getItemId(preview)}-${index}`}>
                        <DnDPreviewCard
                            key={`${getItemId(preview)}-${index}`}
                            index={index}
                            preview={preview}
                            onMovePreview={movePreview}
                            onFileUpload={uploadFile}
                            onRemovePreview={removePreview}
                            onEditPreview={editPreview}
                            aspectRatio={aspectRatio}
                            acceptFormats={acceptFormats}
                            isEmpty={isEmpty}
                            uploadCta={uploadCta}
                        />
                    </div>
                );
            })}
        </Flexbox>
    );
};
